import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { FormGroup, FormGroupDirective, NgForm } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { merge } from 'rxjs';

import { isDefined } from '@mysvg/utils';

@UntilDestroy()
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-form-group',
	styleUrls: ['./form-group.component.scss'],
	templateUrl: './form-group.component.html',
	viewProviders: [{ provide: NgForm, useExisting: FormGroupDirective }],
	standalone: false,
})
export class FormGroupComponent implements OnInit {
	private changeDetectorRef = inject(ChangeDetectorRef);
	private ngForm = inject(NgForm);

	@Input() disabled: boolean = undefined;
	@Input() formGroup: FormGroup;

	ngOnInit(): void {
		// Changes the default value for `updateOn` to `blur`, unless specified otherwise.
		if (!isDefined(this.ngForm.options) || !isDefined(this.ngForm.options.updateOn)) {
			this.ngForm.options = { updateOn: 'blur' };
		}

		merge(this.formGroup.statusChanges, this.formGroup.valueChanges)
			.pipe(untilDestroyed(this))
			.subscribe(() => this.changeDetectorRef.markForCheck());
	}
}
